export const EDITTEXT = {
  hotel_cover: '封面设置',
  hotel_info: '特色信息',
  hotel_position: '修改店铺资料',
  hotel_hall: '场地管理',
  hotel_menu: '菜单管理',
  hotel_package: '套餐管理',
  hotel_active: '微传单',
  hotel_comment: '评价管理',
  hotel_chat: '天眼系统',
  hotel_gift: '专享优惠',
  hotel_case: '婚策案例'
}
